import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const Line = ({ label, o, testid }) => (
  <div className="text-sm" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
    <div>{fmtDate(o.due_date)} · <span className="font-medium">{o.bucket === "vencido" ? "Vencido" : o.bucket === "proximo" ? "Próximo" : o.status_label}</span></div>
    <div className="text-xs text-muted-foreground">OS origen <Link className="text-primary" to={`/admin/os/${o.source_wo_id}`}>{o.source_wo_folio}</Link>{o.maintenance_wo_folio ? <> · OS de mantenimiento <Link className="text-primary" to={`/admin/os/${o.maintenance_wo_id}`}>{o.maintenance_wo_folio}</Link></> : null}</div>
  </div>
);

export const MaintenanceLinkCard = ({ woId, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/maintenance/by-wo/${woId}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [woId, refreshKey]);
  if (!d || (!d.generated && !d.attended)) return null;
  return (
    <section className="fade-up space-y-3 rounded-xl border border-border bg-card/40 p-5" data-testid="wo-maintenance-card">
      <h2 className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">Mantenimiento</h2>
      {d.attended && <Line label="Esta OS atiende el mantenimiento" o={d.attended} testid="wo-maintenance-attended" />}
      {d.generated && <Line label="Próximo mantenimiento generado" o={d.generated} testid="wo-maintenance-generated" />}
      <Link to="/admin/mantenimientos" className="text-xs text-primary" data-testid="wo-maintenance-page-link">Ver mantenimientos</Link>
    </section>
  );
};
